// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//
// };

import firebase from "firebase";
const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyCfYQjumRhRzn3fRHGmrCmFJKlEzHGk8gs",
  authDomain: "osaiteh-s-to-do-app.firebaseapp.com",
  projectId: "osaiteh-s-to-do-app",
  storageBucket: "osaiteh-s-to-do-app.appspot.com",
  messagingSenderId: "789479895797",
  appId: "1:789479895797:web:f374de2659e167477b8bbc",
  measurementId: "G-GFRE0DPRQV"
});
const db = firebase.firestore();
// const auth = firebase.auth();
// const storage = firebase.storage();

export default db;
